import { closeUserModal } from '../State/userModal'

export default () => (dispatch) => {

  dispatch(closeUserModal())
  
}
